export default from './IntermediateResults';



// WEBPACK FOOTER //
// ./src/sharedComponents/Quiz/components/IntermediateResults/index.js